<template>
	<div id="app">
		<nav class="navbar is-warning" role="navigation">
			<div class="navbar-brand">
				<router-link class="navbar-item" to="/categories">Categories</router-link>
				<router-link class="navbar-item" to="/tags">Tags</router-link>
				<router-link class="navbar-item" to="/new">Recent</router-link>
				<router-link class="navbar-item" to="/admin" v-if="isAdmin">Admin</router-link>

				<!-- burger for touch devices only -->
				<a role="button" class="navbar-burger" v-bind:class="{ 'is-active': showNavMenu }" aria-label="menu" aria-expanded="false" v-on:click="ToggleNavbarMenu">
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
					<span aria-hidden="true"></span>
				</a>
			</div>
			<!-- menu for non-touch devices -->
			<div class="navbar-menu" v-bind:class="{ 'is-active': showNavMenu }">
				<div class="navbar-start">
					<div class="navbar-item has-dropdown is-hoverable"
						v-if="userCtx.name">
						<a class="navbar-link">Add</a>

						<div class="navbar-dropdown">
							<a class="navbar-item" href="#/add">From Scratch</a>
							<a class="navbar-item" href="#/import">Import Link</a>
						</div>
					</div>
				</div>
				<div class="navbar-end">
					<section class="section">
						<h1 v-if="userCtx.name">{{ userCtx.name }} ~ <a v-on:click="logout">Logout</a></h1>
						<h1 v-else><a href="#/login">Login</a></h1>
					</section>
				</div>
			</div>
		</nav>
		
		<router-view v-on:login="fetchData" />
	</div>
</template>

<script>
	import {db} from '@/variables.js'

	export default {
		data: function () {
			return {
				showNavMenu: false,
				userCtx: {},
				isAdmin: false,
				timer: ''
			}
		},
		created: function() {
			this.fetchData()
			this.timer = setInterval(this.fetchData, 60000)
		},
		beforeDestroy: function() {
			clearInterval(this.timer)
		},
		watch: {
			'$route': 'CloseNavbarMenu'
		},
		methods: {
			CloseNavbarMenu: function() {
				this.showNavMenu = false
			},
			ToggleNavbarMenu: function() {
				this.showNavMenu = (!this.showNavMenu)
			},
			fetchData: function() {
				var vm = this

				db.getSession( function( err, response ) {
					if( err ) {
						// network error
						console.log( err )
					} else {
						vm.userCtx = response.userCtx
						vm.isAdmin = ( vm.userCtx.roles && ( vm.userCtx.roles.indexOf('_admin') != -1 ) )
						
						console.log("getSession:", response)
					}
				})
			},
			logout: function() {
				var vm = this

				vm.userCtx = {}
				vm.isAdmin = false

				db.logOut( function( err, response ) {
					if( err ) {
						alert( err.message )
						console.log( err )
					} else {
						console.log( response )
						clearInterval(vm.timer)
						vm.timer = ''
					}

					vm.fetchData()
				})
			}
		}
	}
</script>
